import React = require('react');

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../common/utilities/ImgUrl';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { NavListLink } from './NavLink';
import { NavListItemRenderProp, NavListItemState } from './NavList';
import { NavPanelProps } from './NavPanel';

// These test ids have 'top-nav' instead of 'nav-panel' for E2E test backward compatibility

export namespace ContentLinks {

  export function ExploreNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.exploreUrl()}
          name={Messages.explore()}
          iconImagePath={imgPath('spaces_navigation_explore.svg')}
          activeIconImagePath={imgPath('spaces_navigation_explore_active.svg')}
          isCurrentLink={'explore' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-content"
          {...navListItemState} />
      );
    };
  }

  export function FavoritesNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.favoritesUrl()}
          name={Messages.navigation_favorites()}
          iconImagePath={imgPath('spaces_navigation_favorites.svg')}
          activeIconImagePath={imgPath('spaces_navigation_favorites_active.svg')}
          isCurrentLink={'favorites' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-favorites"
          {...navListItemState} />
      );
    };
  }

  export function RecentsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.recentsUrl()}
          name={Messages.navigation_recents()}
          iconImagePath={imgPath('spaces_navigation_recents.svg')}
          activeIconImagePath={imgPath('spaces_navigation_recents_active.svg')}
          isCurrentLink={'recents' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-recents"
          {...navListItemState} />
      );
    };
  }

  export function RecommendationsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.recommendationListUrl()}
          name={Messages.navigation_recommendations()}
          iconImagePath={imgPath('spaces_navigation_recommendations.svg')}
          activeIconImagePath={imgPath('spaces_navigation_recommendations_active.svg')}
          isCurrentLink={'recommendations' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-recommendations"
          {...navListItemState} />
      );
    };
  }

  export function HomeNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.homeUrl()}
          name={Messages.home()}
          iconImagePath={imgPath('spaces_navigation_home.svg')}
          activeIconImagePath={imgPath('spaces_navigation_home_active.svg')}
          isCurrentLink={'home' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-home"
          {...navListItemState} />
      );
    };
  }

  export function CatalogNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.catalogUrl()}
          name={Messages.externalAssets()}
          iconImagePath={imgPath('spaces_navigation_catalog.svg')}
          activeIconImagePath={imgPath('spaces_navigation_catalog_active.svg')}
          isCurrentLink={'catalog' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-catalog"
          {...navListItemState} />
      );
    };
  }

  export function CollectionsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.collectionsUrl()}
          name={'Collections'}
          iconImagePath={imgPath('spaces_navigation_collections_active.svg')}  // Request disabled collection - 18px
          activeIconImagePath={imgPath('spaces_navigation_collections_active.svg')}
          isCurrentLink={'collections' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-collections"
          {...navListItemState} />
      );
    };
  }

  export function SharedWithMeNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.sharedWithMeUrl()}
          name={Messages.navigation_sharedWithMe()}
          iconImagePath={imgPath('spaces_navigation_shared_with_me.svg')}
          activeIconImagePath={imgPath('spaces_navigation_shared_with_me_active.svg')}
          isCurrentLink={'shared_with_me' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-shared-with-me"
          {...navListItemState} />
      );
    };
  }

  export function PersonalSpaceNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.personalSpaceUrl()}
          name={Messages.navigation_personalSpace()}
          iconImagePath={imgPath('spaces_navigation_me.svg')}
          activeIconImagePath={imgPath('spaces_navigation_me_active.svg')}
          isCurrentLink={'personal_space' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-personal-space"
          {...navListItemState} />
      );
    };
  }
}


export namespace SiteLinks {

  export function UsersNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.usersUrl()}
          name={Messages.users()}
          iconImagePath={imgPath('spaces_navigation_admin_people.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_people_active.svg')}
          isCurrentLink={'site_users' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-users"
          {...navListItemState} />
      );
    };
  }

  export function GroupsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.groupsUrl()}
          name={Messages.groups()}
          iconImagePath={imgPath('spaces_navigation_admin_groups.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_groups_active.svg')}
          isCurrentLink={'site_groups' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-groups"
          {...navListItemState} />
      );
    };
  }

  export function SchedulesNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.schedulesUrl()}
          name={Messages.schedules()}
          iconImagePath={imgPath('spaces_navigation_admin_schedules.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_schedules_active.svg')}
          isCurrentLink={'site_schedules' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-schedules"
          {...navListItemState} />
      );
    };
  }

  export function JobsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.jobsUrl()}
          name={Messages.backgroundJobs()}
          iconImagePath={imgPath('spaces_navigation_admin_jobs.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_jobs_active.svg')}
          isCurrentLink={'site_jobs' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-jobs"
          {...navListItemState} />
      );
    };
  }

  export function TasksNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      const hrefLink = props.siteUrls.tasksExtractRefreshesUrl();
      return (
        <NavListLink
          href={hrefLink}
          name={Messages.tasks()}
          iconImagePath={imgPath('spaces_navigation_admin_tasks.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_tasks_active.svg')}
          isCurrentLink={'site_tasks' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-tasks"
          {...navListItemState} />
      );
    };
  }

  export function StatusNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.statusUrl()}
          name={Messages.siteStatus()}  // should be lower cased?
          iconImagePath={imgPath('spaces_navigation_admin_site_status.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_site_status_active.svg')}
          isCurrentLink={'site_status' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-status"
          {...navListItemState} />
      );
    };
  }

  export function SettingsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.siteUrls.settingsUrl()}
          name={Messages.settings()}
          iconImagePath={imgPath('spaces_navigation_admin_settings.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_settings_active.svg')}
          isCurrentLink={'site_settings' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-site-settings"
          {...navListItemState} />
      );
    };
  }
}


export namespace ServerLinks {
  export function SitesNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.sitesUrl()}
          name={Messages.sites()}
          iconImagePath={imgPath('spaces_navigation_sites.svg')}
          activeIconImagePath={imgPath('spaces_navigation_sites_active.svg')}
          isCurrentLink={'server_sites' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-sites"
          {...navListItemState} />
      );
    };
  }

  export function UsersNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.usersUrl()}
          name={Messages.users()}
          iconImagePath={imgPath('spaces_navigation_admin_people.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_people_active.svg')}
          isCurrentLink={'server_users' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-users"
          {...navListItemState} />
      );
    };
  }

  export function SchedulesNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.schedulesUrl()}
          name={Messages.schedules()}
          iconImagePath={imgPath('spaces_navigation_admin_schedules.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_schedules_active.svg')}
          isCurrentLink={'server_schedules' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-schedules"
          {...navListItemState} />
      );
    };
  }

  export function JobsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.jobsUrl()}
          name={Messages.backgroundJobs()}
          iconImagePath={imgPath('spaces_navigation_admin_jobs.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_jobs_active.svg')}
          isCurrentLink={'server_jobs' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-jobs"
          {...navListItemState} />
      );
    };
  }

  export function TasksNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.tasksUrl()}
          name={Messages.tasks()}
          iconImagePath={imgPath('spaces_navigation_admin_tasks.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_tasks_active.svg')}
          isCurrentLink={'server_tasks' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-tasks"
          {...navListItemState} />
      );
    };
  }

  export function StatusNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.statusUrl()}
          name={Messages.serverStatus()}
          iconImagePath={imgPath('spaces_navigation_admin_site_status.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_site_status_active.svg')}
          isCurrentLink={'server_status' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-status"
          {...navListItemState} />
      );
    };
  }

  export function SettingsNavListLink(props: NavPanelProps): NavListItemRenderProp {
    return function(navListItemState: NavListItemState): JSX.Element {
      return (
        <NavListLink
          href={props.serverUrls.settingsUrl()}
          name={Messages.settings()}
          iconImagePath={imgPath('spaces_navigation_admin_settings.svg')}
          activeIconImagePath={imgPath('spaces_navigation_admin_settings_active.svg')}
          isCurrentLink={'server_settings' === props.currentNavLocation}
          navPanelDisplayMode={props.navPanelDisplayMode}
          testId="top-nav-server-settings"
          {...navListItemState} />
      );
    };
  }
}
